export enum WageAndTravelViewType {
    RequestData = 0,
    ConfirmDonation = 1,
    VerifyWage = 2,
    ReimburseWage = 3,
    ReimburseWageAudit = 31,
    VerifyTravel = 4,
    VerifyAmount = 41,
    VerifyStub = 42,
    ReimburseTravel = 5,
    AdditionalDays = 6,
    CancelRequest = 7,
    DeclineRequest = 8,
    RequestAdditionalDays = 10,
    ApproveWeekReimbursements = 11,
    PaymentError = 12,
    ImportTransactionFile = 13,
    ConfirmTravelReiembursement = 14,
    ConfirmWageReiembursement = 15,
    ValidateBankInfo = 16,
    ApprovalEmail = 17
}